type RGB = [number, number, number];

export type ThemeName = 'theme1' | 'theme2';

export interface ThemePalette {
  primary: RGB;
  secondary: RGB;
  background: RGB;
  highlight: RGB;
}

export const THEMES: Record<ThemeName, ThemePalette> = {
  theme1: {
    primary: [59, 78, 102],
    secondary: [59, 78, 102],
    background: [247, 250, 253],
    highlight: [205, 227, 241],
  },
  theme2: {
    primary: [40, 62, 92],
    secondary: [40, 62, 92],
    background: [244, 247, 255],
    highlight: [234, 238, 251],
  },
};

export function applyTheme(name: ThemeName) {
  const palette = THEMES[name];
  if (!palette) return;
  const root = document.documentElement;
  root.style.setProperty('--color-primary', `${palette.primary[0]} ${palette.primary[1]} ${palette.primary[2]}`);
  root.style.setProperty('--color-secondary', `${palette.secondary[0]} ${palette.secondary[1]} ${palette.secondary[2]}`);
  root.style.setProperty('--color-background', `${palette.background[0]} ${palette.background[1]} ${palette.background[2]}`);
  root.style.setProperty('--color-highlight', `${palette.highlight[0]} ${palette.highlight[1]} ${palette.highlight[2]}`);
  root.setAttribute('data-theme', name);
}

export function initThemeFromPrefs() {
  try {
    const url = new URL(window.location.href);
    const paramTheme = (url.searchParams.get('theme') as ThemeName) || null;
    const saved = (localStorage.getItem('theme') as ThemeName) || null;
    const chosen = (paramTheme || saved || 'theme2') as ThemeName;
    applyTheme(chosen);
    if (paramTheme) localStorage.setItem('theme', paramTheme);
  } catch {
    applyTheme('theme2');
  }
}
